import { render, staticRenderFns } from "./MyCompanyForm.vue?vue&type=template&id=3a4a4077&scoped=true&"
import script from "./MyCompanyForm.vue?vue&type=script&lang=js&"
export * from "./MyCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyForm.vue?vue&type=style&index=0&id=3a4a4077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a4077",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VTextField})
